import script from "./HomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=3d652d37&lang=css"
import "./HomeView.vue?vue&type=style&index=1&id=3d652d37&scoped=true&lang=css"

import exportComponent from "/home/runner/work/coming-soon-template/coming-soon-template/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d652d37"]])

export default __exports__